export const getVersionFromLang = (lang: string) => {
  switch (lang) {
    default:
      return `${lang}_1.0.0`
  }
}
